<template>
  <div class="relative">
    <div class="vx-navbar-wrapper">
      <vs-navbar class="vx-navbar navbar-custom" :color="navbarColor" :class="classObj">
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer mr-1" icon="MenuIcon" @click.stop="showSidebar"></feather-icon>

        <template v-if="breakpoint != 'md'">
          <!-- STARRED PAGES -
          <ul class="vx-navbar__starred-pages" v-if="dispositivo.desktop.uid === 0">
            <draggable class="flex">
              <li class="starred-page">
                <vx-tooltip position="bottom" delay="55555.3s">
                  <router-link to="/mobile/whatsapp-chat">
                    <vs-icon class="pl-2 pr-2 h-10 w-10" icon-pack="fab" icon="fa-whatsapp"></vs-icon>
                  </router-link>
                  <router-link to="/mobile/chamadas">
                    <vs-icon class="pl-2 pr-2 h-10 w-10" icon-pack="far" icon="fa-phone"></vs-icon>
                  </router-link>
                  <router-link to="/mobile/localizacao">
                    <vs-icon class="pl-2 pr-2 h-10 w-10" icon-pack="far" icon="fa-map-marker-alt"></vs-icon>
                  </router-link>
                  <router-link to="/mobile/teclas">
                    <vs-icon class="pl-2 pr-2 h-10 w-10" icon-pack="far" icon="fa-keyboard"></vs-icon>
                  </router-link>
                </vx-tooltip>
              </li>
            </draggable>
          </ul>
          FIRST 10-->

          <!-- STARRED PAGES MORE -->
          <div class="vx-navbar__starred-pages--more-dropdown" v-if="starredPagesMore.length">
            <vs-dropdown vs-custom-content vs-trigger-click>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="cursor-pointer p-2"></feather-icon>
              <vs-dropdown-menu>
                <ul class="vx-navbar__starred-pages-more--list">
                  <draggable v-model="starredPagesMore" :group="{name: 'pinList'}" class="cursor-move">
                    <li
                      class="starred-page--more flex items-center cursor-pointer"
                      v-for="page in starredPagesMore"
                      :key="page.url"
                      @click="$router.push(page.url)"
                    >
                      <feather-icon svgClasses="h-5 w-5" class="ml-2 mr-1" :icon="page.labelIcon"></feather-icon>
                      <span class="px-2 pt-2 pb-1">{{ page.label }}</span>
                    </li>
                  </draggable>
                </ul>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
          <!--
				<div class="bookmark-container">
					<feather-icon icon="StarIcon" :svgClasses="['stoke-current text-warning', {'text-white': navbarColor != '#fff'}]" class="cursor-pointer p-2" @click.stop="showBookmarkPagesDropdown = !showBookmarkPagesDropdown" />
                    <div v-click-outside="outside" class="absolute bookmark-list w-1/3 xl:w-1/4 mt-4" v-if="showBookmarkPagesDropdown">
					<vx-auto-suggest :autoFocus="true" :data="navbarSearchAndPinList" @selected="selected" @actionClicked="actionClicked" inputClassses="w-full" show-action show-pinned background-overlay></vx-auto-suggest>
					</div>
				</div>
          -->
        </template>

        <vs-spacer></vs-spacer>


        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
          <span class="cursor-pointer flex i18n-locale">
            <img class="h-4 w-5" :src="require(`@/assets/images/flags/${$i18n.locale}.png`)" :alt="$i18n.locale" />
            <span class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span>
          </span>
          <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
            <vs-dropdown-item @click="updateLocale('en')">
              <img class="h-4 w-5 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;EN
            </vs-dropdown-item>
            <vs-dropdown-item @click="updateLocale('pt')">
              <img class="h-4 w-5 mr-1" src="@/assets/images/flags/br.png" alt="pt" /> &nbsp;PT
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- SEARCHBAR
        <div
          class="search-full-container w-full h-full absolute left-0 rounded-lg"
          :class="{'flex': showFullSearch}"
          v-show="showFullSearch"
        >
          <vx-auto-suggest
            class="w-full"
            inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus no-icon-border"
            :autoFocus="showFullSearch"
            :data="navbarSearchAndPinList"
            icon="SearchIcon"
            placeholder="Buscar..."
            ref="navbarSearch"
            @closeSearchbar="showFullSearch = false"
            @selected="selected"
            background-overlay
          />
          <div class="absolute right-0 h-full z-50">
            <feather-icon
              icon="XIcon"
              class="px-4 cursor-pointer h-full close-search-icon"
              @click="showFullSearch = false"
            ></feather-icon>
          </div>
        </div>
        <feather-icon icon="SearchIcon" @click="showFullSearch = true" class="cursor-pointer navbar-fuzzy-search ml-4"></feather-icon>
        &nbsp;&nbsp;-->
        <!-- CART DROPDOWN
            <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                <feather-icon icon="ShoppingCartIcon" class="cursor-pointer ml-4 mr-6 mt-1" :badge="cartItems.length"></feather-icon>
                <vs-dropdown-menu class="cart-dropdown vx-navbar-dropdown" :class="{'dropdown-custom': cartItems.length}">

                     IF CART HAVE ITEMS: HEADER
                    <template v-if="cartItems.length">
                        <div class="notification-header text-center p-5 bg-primary text-white">
                            <h3 class="text-white">{{ cartItems.length }} Item<span v-show="cartItems.length > 1">s</span></h3>
                            <p class="opacity-75">In Your Cart</p>
                        </div>

                         CART ITEMS
                        <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--cart-items-dropdowm p-0 mb-10" :settings="settings">
                        <ul class="bordered-items">
                            <li v-for="item in cartItems" :key="item.objectID" class="vx-row no-gutter cart-item cursor-pointer">

                                 IMG COL
                                <div class="vx-col w-1/5 item-img-container bg-white flex items-center justify-center">
                                    <img :src="item.image" alt="item" class="cart-dropdown-item-img p-4">
                                </div>

                                 INFO COL
                                <div class="vx-col w-4/5 pr-4 pl-2 py-4 flex flex-col justify-center">
                                    <span class="font-medium block cart-item-title truncate">{{ item.name }}</span>
                                    <small class="truncate mb-2">{{ item.description }}</small>
                                    <div class="flex items-center justify-between">
                                        <span class="text-sm font-medium">{{ item.quantity }} <small>x</small> ${{ item.price }}</span>
                                        <feather-icon icon="XIcon" svgClasses="h-4 w-4 cursor-pointer text-danger" class="hover:text-danger" @click.stop="removeItemFromCart(item)" />
                                    </div>
                                </div>
                            </li>
                        </ul>
                        </VuePerfectScrollbar>
                        <div
                            class=" checkout-footer fixed bottom-0 rounded-b-lg text-primary font-semibold w-full p-2 text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer"
                            @click="$router.push('/apps/eCommerce/checkout')">

                            <span class="flex items-center justify-center">
                              <feather-icon icon="ShoppingCartIcon" svgClasses="h-4 w-4"></feather-icon>
                              <span class="ml-2">Checkouts</span>
                            </span>

                        </div>
                    </template>

                     IF CART IS EMPTY
                    <template v-else>
                        <p class="p-4">Your Cart Is Empty.</p>
                    </template>
                </vs-dropdown-menu>
            </vs-dropdown>
        -->

        <feather-icon icon="PlusIcon" class="cursor-pointer mt-1 mr-4" @click="novo"></feather-icon>

        <feather-icon icon="DownloadIcon" class="cursor-pointer mt-1 mr-4" @click="$router.push('/conta/download')"></feather-icon>

        <!-- <feather-icon
          icon="SettingsIcon"
          class="cursor-pointer mt-1 mr-4"
          @click="$store.commit('TOGGLE_IS_SETTINGS_ACTIVE', true)"
        ></feather-icon> -->

        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
          &nbsp;
          <feather-icon icon="UserIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2"></feather-icon>
          <div class="con-img ml-3"></div>
          <vs-dropdown-menu class="vx-navbar-dropdown">
            <ul style="min-width: 9rem">
              <li
                class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                @click="$router.push('/conta/perfil')"
              >
                <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">Conta</span>
              </li>
              <li
                class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                @click="$router.push('/pages/faq')"
              >
                <feather-icon icon="InfoIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">Atendimento</span>
              </li>
              <!--
              <li
                class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white whitespace-no-wrap"
                @click="$router.push('/transferir-dispositivos')"
              >
                <feather-icon icon="RefreshCwIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">Transferir Dispositivos</span>
              </li>
              -->
              <li
                class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white whitespace-no-wrap"
                @click="$router.push('/transferir-licenca')"
              >
                <feather-icon icon="RefreshCwIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">Transferir Licenças</span>
              </li>
              <li
                class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white whitespace-no-wrap"
                @click="$router.push('/pages/faq')"
              >
                <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">Perguntas Frequentes</span>
              </li>

              <vs-divider class="m-1"></vs-divider>

              <li
                class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white whitespace-no-wrap"
                @click="logout"
              >
                <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">Sair do Painel</span>
              </li>
            </ul>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- USER META
        <div class="the-navbar__user-meta flex items-center">

          <div class="text-right leading-tight hidden sm:block">
            <a href="javascript:;" @click="$router.push('/pages/profile')" class="font-semibold">Conta</a>
            &nbsp;
            <a href="javascript:;" @click="$router.push('/pages/profile')" class="font-semibold">Sair</a>
          </div>
        </div>-->
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import draggable from "vuedraggable";

export default {
  name: "the-navbar",
  props: {
    navbarColor: {
      type: String,
      default: "#fff"
    }
  },
  data() {
    return {
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      searchQuery: "",
      showFullSearch: false,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      autoFocusSearch: false,
      showBookmarkPagesDropdown: false
    };
  },
  watch: {
    $route() {
      if (this.showBookmarkPagesDropdown)
        this.showBookmarkPagesDropdown = false;
    }
  },
  computed: {
    // HELPER
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.sidebarWidth == "default") return "navbar-default";
      else if (this.sidebarWidth == "reduced") return "navbar-reduced";
      else if (this.sidebarWidth) return "navbar-full";
    },

    // I18N
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale == "en") return { flag: "us", lang: "EN" };
      else if (locale == "pt") return { flag: "br", lang: "PT" };
    },

    // BOOKMARK & SEARCH
    data() {
      return this.$store.state.navbarSearchAndPinList;
    },
    starredPages() {
      return this.$store.state.starredPages;
    },
    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesLimited", list);
      }
    },
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesMore", list);
      }
    },

    // CART DROPDOWN
    cartItems() {
      return this.$store.state.eCommerce.cartItems.slice().reverse();
    }
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale;
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
    },
    selected(item) {
      this.$router.push(item.url);
      this.showFullSearch = false;
    },
    actionClicked(item) {
      // e.stopPropogation();
      this.$store.dispatch("updateStarredPage", {
        index: item.index,
        val: !item.highlightAction
      });
    },
    showNavbarSearch() {
      this.showFullSearch = true;
    },
    showSearchbar() {
      this.showFullSearch = true;
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? `${seconds} sec ago` : "just now");
      }

      return "Just Now";
    },
    logout() {
      const userId = localStorage.getItem("userId");
      window.Echo.leave(`mobile.${userId}`)

      this.$localStorage.remove("userId");
      this.$localStorage.remove("token");
      this.$localStorage.remove("uid");
      this.$localStorage.remove("user");
      this.$EventBus.$emit("deviceChanged", null);
      this.$router.push("/pages/login");
    },
    novo() {
      this.$router.push("/novo-dispositivo");
    },
    outside: function() {
      this.showBookmarkPagesDropdown = false;
    },

    // CART DROPDOWN
    removeItemFromCart(item) {
      this.$store.dispatch("eCommerce/toggleItemInCart", item);
    }
  },
  directives: {
    "click-outside": {
      bind: function(el, binding) {
        const bubble = binding.modifiers.bubble;
        const handler = e => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        document.addEventListener("click", handler);
      },

      unbind: function(el) {
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    draggable
  }
};
</script>
